import React, { useEffect } from 'react';

const Footer: React.FC = () => {
    const handleConsentPreferences = (e: React.MouseEvent<HTMLAnchorElement>) => {
        e.preventDefault();
        
        // Try multiple ways Termly might expose the display preferences function
        const win = window as any;
        
        if (win.displayPreferenceModal) {
            win.displayPreferenceModal();
        } else if (win.termly?.displayPreferenceModal) {
            win.termly.displayPreferenceModal();
        } else if (win.Termly?.displayPreferenceModal) {
            win.Termly.displayPreferenceModal();
        } else if (win.termlyDisplayPreferences) {
            win.termlyDisplayPreferences();
        } else {
            // Fallback: let the default behavior happen (Termly should handle it via class)
            // But also try to find and click any Termly-managed element
            const termlyButton = document.querySelector('a.termly-display-preferences, button.termly-display-preferences');
            if (termlyButton) {
                (termlyButton as HTMLElement).click();
            }
        }
    };

    useEffect(() => {
        // Ensure Termly has time to initialize and attach handlers
        const timer = setTimeout(() => {
            const element = document.querySelector('.termly-display-preferences');
            if (element && !element.hasAttribute('data-termly-initialized')) {
                element.setAttribute('data-termly-initialized', 'true');
            }
        }, 1000);

        return () => clearTimeout(timer);
    }, []);

    return (
        <footer className='w-full py-6 px-4 mt-auto'>
            <div className='max-w-7xl mx-auto'>
                <div className='flex flex-col sm:flex-row items-center justify-center gap-4 sm:gap-6'>
                    <a
                        href='https://puzzleplanet.io/privacy'
                        target='_blank'
                        rel='noopener noreferrer'
                        className='text-gray-400 hover:text-white text-sm transition-colors duration-200'
                    >
                        Privacy Policy
                    </a>
                    <span className='hidden sm:inline text-gray-500'>|</span>
                    <a
                        href='https://puzzleplanet.io/terms'
                        target='_blank'
                        rel='noopener noreferrer'
                        className='text-gray-400 hover:text-white text-sm transition-colors duration-200'
                    >
                        Terms of Service
                    </a>
                    <span className='hidden sm:inline text-gray-500'>|</span>
                    {/* eslint-disable-next-line jsx-a11y/anchor-is-valid */}
                    <a
                        href='#'
                        onClick={handleConsentPreferences}
                        className='termly-display-preferences text-gray-400 hover:text-white text-sm transition-colors duration-200'
                    >
                        Cookies
                    </a>
                </div>
            </div>
        </footer>
    );
};

export default Footer;
